import React, {Component} from 'react'
import PropTypes from 'prop-types'
import FilterDateRangeV2 from '../../home/components/filters/FilterDateRangeV2'
import {Input, Select} from 'antd'
import string2Array from '../../../helpers/string2Array'

const {Search} = Input

class FilterBatches extends Component {
    inputName = React.createRef()
    state = {
        hasInputName: false,
    }
    timeout = null
    _handleChangeInput = (prop) => (value) => {
        const {onChangeFilters} = this.props
        value = value.target ? value.target.value : value


        if (prop === 'name') {
            value = string2Array(value).map(s => `${s}`.toUpperCase())

            if (this.inputName.current) {
                this.setState({
                    hasInputName: value.length,
                })
            }
        }

        this.timeout && clearTimeout(this.timeout)

        if (prop === 'name') {
            return (this.timeout = setTimeout(() => {
                onChangeFilters && onChangeFilters({[prop]: value})
            }, 500))
        }

        onChangeFilters && onChangeFilters({[prop]: value})
    }

    _handleChangeMultiSelect = (prop) => (values) => {
        this._handleChangeInput(prop)(values)
    }

    _handleChangeDate = (field, value) => {
        const {from, to} = {...value}
        this._handleChangeInput(field)(from === '' || to === '' ? {} : {from, to})
    }

    render() {
        const {
            listUsers = [],
            listProducts = [],
            filters,
        } = this.props
        const {
            users = [],
            products = [],
        } = {...filters}

        return (
            <div className="BatchesPageContainer">
                <div className="row align-items-end">
                    <div className="FilterNameBatch col-12 col-xl-2 mb-3">
                        <label className="font-weight-bold">Tên lô</label>
                        <div
                            className={['SearchField', this.state.hasInputName && 'not-empty'].filter(Boolean).join(' ')}>
                            <Search ref={this.inputName} itemRef={this.inputName} placeholder="Tìm kiếm theo tên Lô..."
                                    onChange={this._handleChangeInput('name')}
                                    allowClear={true}/>
                        </div>
                    </div>
                    <div className="col-12 col-xl-4 mb-3">
                        <label className="font-weight-bold">Ngày đóng gói</label>
                        <FilterDateRangeV2 field="packaged_at" onDatesChange={this._handleChangeDate} showTime={true}/>
                    </div>


                    <div className="col-12 col-xl-4 mb-3">
                        <label className="font-weight-bold">Loại sản phẩm</label>
                        <Select
                            mode="multiple"
                            style={{width: '100%'}}
                            showArrow={true}
                            placeholder="Loại sản phẩm"
                            defaultValue={products}
                            onChange={this._handleChangeMultiSelect('products')}
                            value={products}
                            allowClear
                        >
                            {
                                !!listProducts && !!listProducts.length && listProducts.map((option) => {
                                    return <Select.Option key={option._id}
                                                          value={option.sku}>{option.sku}</Select.Option>
                                })
                            }
                        </Select>
                    </div>

                    <div className="col-12 col-xl-2 mb-3">
                        <label className="font-weight-bold">Người đóng gói</label>
                        <Select
                            mode="multiple"
                            style={{width: '100%'}}
                            showArrow={true}
                            placeholder="Người đánh dấu đóng thùng"
                            defaultValue={users}
                            onChange={this._handleChangeMultiSelect('users')}
                            value={users}
                            allowClear
                        >
                            {
                                !!listUsers && !!listUsers.length && listUsers.map((option, index) => {
                                    return <Select.Option key={index} value={option}>{option}</Select.Option>
                                })
                            }
                        </Select>
                    </div>
                </div>
            </div>
        )
    }

}

FilterBatches.propTypes = {
    loading: PropTypes.bool,
    onChangeFilters: PropTypes.func.isRequired,
    listUsers: PropTypes.array,
    listProducts: PropTypes.array,
    filters: PropTypes.object,
}

export default FilterBatches
